// extracted by mini-css-extract-plugin
export default {"childrenWrapper":"DJg7g","popper":"xux7D","arrow":"BJ5Ty","hint":"_xR3C","popperContent":"VKxbW","markdown":"T_nK8","hintContent":"lqvGS","closeButton":"qh1eC"};